import { render } from "./RequestsPage.vue?vue&type=template&id=0639386a&scoped=true"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"

import "./RequestsPage.vue?vue&type=style&index=0&id=0639386a&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0639386a"]])

export default __exports__